import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';

// Used for the rollout of visual refresh.
// The rollout of visual refresh has merged with the rollout of nav4 to make sure customers always experience them together.
// Note, this means mocking nav4 will typically turn on most visual refresh changes as well.
// Some differences will still occur in Storybook examples when using visual refresh mocks vs nav4 mocks.
// Visual refresh Storybook mocks also turn on platform component and icon flags.
export const isVisualRefreshEnabled = () => getWillShowNav4();
